import { Outlet } from 'react-router-dom';

function ProcessSettingPage() {
	return <Outlet />;
}

export default ProcessSettingPage;
